import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CarType } from 'src/app/core/models/transport-operation/car-type';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContainerService {


  constructor(
    private http: HttpClient
  ) { }

  /**
   * query Container By Filter
   * @param model condition on UI
   */
  queryContainer(model: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/logistics/container/queryContainer`;
    return this.http.post(url, model);
  }

  /**
   * query Do detail by container SeqNo
   * @param seqNo container Seq No
   */
  queryDoDetailByContainerSeqNo(seqNo: number): Promise<any>{
    const httpOptions = {
      params: {
        containerSeqNo: seqNo.toString()
      },
    };

    const url = `${environment.logisticsApiUrl}/logistics/container/doDetail`;
    return this.http.post(url, null, httpOptions).toPromise();
  }

  /**
   * transfer do between containers
   * @param transformObj obj
   */
  transform(transformObj: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/logistics/container/transform`;
    return this.http.post(url, transformObj);
  }

  lock(status: number, obj: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/logistics/container/lock/${status}`;
    return this.http.post(url, obj);
  }

  queryContainerOne(model: any): Promise<any>{
    const url = `${environment.logisticsApiUrl}/logistics/container/ContainerOne`;
    return this.http.post(url, model).toPromise();
  }

  transformOnOne(transformObj: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/logistics/container/transformOnOne`;
    return this.http.post(url, transformObj);
  }

  export(obj: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/logistics/container/export`;
    return this.http.post(url, obj, { responseType: 'blob'});
  }

  containerChangeInfo(info: any): Observable<any>{
    const url = `${environment.whOutboundApiUrl}/container/changeInfo`;
    return this.http.post(url, info);
  }

  checkExpressBill(checkObj: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/logistics/container/checkExpressBill`;
    return this.http.post(url, checkObj);
  }

  getOrphanHeader(req: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/logistics/container/orphan`;
    return this.http.post(url, req);
  }

  getOrphanDetail(containerSeqNo: number): Observable<any>{
    const url = `${environment.logisticsApiUrl}/logistics/container/orphan/${containerSeqNo}`;
    return this.http.get(url);
  }

  transformCheck(type: string, transformObj: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/logistics/container/transformCheck/${type}`;
    return this.http.post(url, transformObj);
  }

  getCarType(facility: string): Observable<CarType[]>{
    const url = `${environment.logisticsApiUrl}/logistics/container/carType/${facility}`;
    return this.http.get<CarType[]>(url);
  }

  getCarTypeByAllFacility(): Observable<CarType[]>{
    const url = `${environment.logisticsApiUrl}/logistics/container/getCarTypeByAllFacility`;
    return this.http.get<CarType[]>(url);
  }

  returnData(req: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/logistics/container/returnData`;
    return this.http.post(url, req);
  }

  exportContainerDataDetailExcel(request: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/report/getContainerDataDetailExcel`;
    return this.http.post(url, request, { responseType: 'blob' });
  }

  sendContainerBoxDetailExcel(req: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/logistics/container/sendContainerBoxDetailExcel`;
    return this.http.patch(url, req);
  }

  downloadContainerSignReceipt(containerCode: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/logistics/container/downloadContainerSignReceipt`;
    return this.http.post(url, containerCode);
  }
  downloadUnBondedDoc(containerCode: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/logistics/container/downloadUnBondedDoc`;
    return this.http.post(url, containerCode);
  }

  triggerContainerPackingCombo(containerCode: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/logistics/container/triggerContainerPackingCombo`;
    return this.http.post(url, containerCode);
  }

  getChangeContainerSetting(): any {
    const url = `${environment.logisticsApiUrl}/appCsmSetting/getAppCsmSettingByCsmCode/ChangeContainer`;
    return this.http.get(url);
  }

  createContainerMA(req:any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/logistics/container/createContainerMA`;
    return this.http.post(url, req);
  }

  getTrDefaultPaymentBy(facilityCode: string): Observable<any> {
    const url = `${environment.logisticsApiUrl}/logistics/container/TrDefaultPaymentBy/${facilityCode}`;
    return this.http.get(url);
  }

  mergeContainer(mergContainers: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/logistics/container/mergeContainer`;
    return this.http.post(url, mergContainers);
  }

  getTruckRegisterSeq(facilityCode: string): Observable<any>{
    const url = `${environment.logisticsApiUrl}/logistics/container/getTruckRegisterSeq/${facilityCode}`;
    return this.http.get(url);
  }

  checkMultipleAddress(checkMultipleAddressParams: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/logistics/container/checkMultipleAddress`;
    return this.http.post(url, checkMultipleAddressParams);
  }

}
